import { styled } from 'lib/theme'

export const Form = styled('form', {})
